import { motion } from 'framer-motion';
import { Wallet, AlertTriangle, XCircle, RefreshCw } from 'lucide-react';

export const WalletErrorBubble = ({ error, onConnectWallet, onSetMinimum, onRetry, onAdjustLiquidity }) => {
  if (!error) return null;

  const errorConfigs = {
    'not-connected': {
      icon: <Wallet className="gm-wallet-err-icon gm-text-amber" />,
      message: 'Please connect your wallet to continue.',
      action: onConnectWallet && (
        <button onClick={onConnectWallet} className="gm-wallet-err-action-btn">
          <Wallet className="gm-icon-sm" />
          Connect Wallet
        </button>
      ),
    },
    'min-liquidity': {
      icon: <AlertTriangle className="gm-wallet-err-icon gm-text-destructive" />,
      message: 'Minimum liquidity is ',
      action: onSetMinimum && (
        <span>
          <button
            onClick={onSetMinimum}
            className="gm-wallet-err-link"
          >
            $0.01
          </button>
          .
        </span>
      ),
    },
    'insufficient-balance': {
      icon: <AlertTriangle className="gm-wallet-err-icon gm-text-destructive" />,
      message: 'Insufficient balance to provide the selected liquidity.',
      action: onAdjustLiquidity && (
        <button onClick={onAdjustLiquidity} className="gm-wallet-err-secondary-btn">
          Adjust Liquidity
        </button>
      ),
    },
    'tx-rejected': {
      icon: <XCircle className="gm-wallet-err-icon gm-text-amber" />,
      message: 'Transaction was cancelled. The market has not been deployed.',
      action: onRetry && (
        <button onClick={onRetry} className="gm-wallet-err-action-btn">
          <RefreshCw className="gm-icon-sm" />
          Try Again
        </button>
      ),
    },
    'deploy-failed': {
      icon: <XCircle className="gm-wallet-err-icon gm-text-destructive" />,
      message: 'Deployment failed due to a network error. Your market remains in preview.',
      action: onRetry && (
        <button onClick={onRetry} className="gm-wallet-err-action-btn">
          <RefreshCw className="gm-icon-sm" />
          Retry Deployment
        </button>
      ),
    },
    'gas-fee-error': {
      icon: <AlertTriangle className="gm-wallet-err-icon gm-text-amber" />,
      message: 'Could not estimate network fees. Please check your connection and try again.',
      action: onRetry && (
        <button onClick={onRetry} className="gm-wallet-err-action-btn">
          <RefreshCw className="gm-icon-sm" />
          Retry
        </button>
      ),
    },
  };

  const config = errorConfigs[error];
  if (!config) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -10, scale: 0.95 }}
      className="gm-wallet-err"
    >
      <div className="gm-wallet-err-body">
        <div className="gm-wallet-err-icon-wrap">{config.icon}</div>
        <div className="gm-wallet-err-content">
          <p className="gm-wallet-err-msg">
            {error === 'min-liquidity' ? (
              <>
                {config.message}
                {config.action}
              </>
            ) : (
              config.message
            )}
          </p>
          {error !== 'min-liquidity' && config.action}
        </div>
      </div>
    </motion.div>
  );
};
